import { type ReactNode } from 'react';
import { useLocation } from 'wouter';
import { cn } from '@/lib/utils';

interface ProposalLayoutProps {
  children: ReactNode;
}

const PROPOSAL_NAV_ITEMS = [
  { href: '/proposals', label: '方案列表' },
  { href: '/proposals/create', label: '新建方案' },
  { href: '/proposals/ai-review-dashboard', label: 'AI 审核看板' },
];

export default function ProposalLayout({ children }: ProposalLayoutProps) {
  const [location] = useLocation();
  return (
    <div className="flex flex-col gap-6">
      <div className="border-b border-border">
        <nav className="flex gap-8 px-6 py-3">
          {PROPOSAL_NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={cn(
                'text-sm font-medium transition-colors',
                location === item.href || (item.href !== '/proposals' && location.startsWith(item.href))
                  ? 'border-b-2 border-primary text-primary pb-3'
                  : 'text-muted-foreground hover:text-foreground pb-3',
              )}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
      <div className="px-6">{children}</div>
    </div>
  );
}
